<template>
  <!-- Contenedor -->
  <div
    class="
      d-flex
      align-items-center
      justify-content-around
      w-100
      p-2
      py-4
      rounded
      sombra
    "
  >
    <!-- Column Izquierda -->
    <div class="d-flex flex-column">
      <!-- Numero -->
      <div class="number" v-text="data.number"></div>
      <!-- Texto -->
      <div v-text="data.text"></div>
    </div>

    <!-- Column Derecha -->
    <div class="d-flex justify-content-center align-items-center">
      <div style="position: relative !important; width: 50px; height: 50px">
        <i
          :class="data.icon"
          style="position: absolute"
          class="icon contenedor"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  mounted() {},
};
</script>

<style>
/* i {
  font-size: 55px;
  transition: 0.3s;
}
i:hover {
  font-size: 55px;
  transition: 0.3s;
} */

.sombra {
  border: solid 1px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 1px 8px -1px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px 1px 8px -1px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 1px 8px -1px rgba(0, 0, 0, 0.15);
}

.icon {
  font-size: 50px !important;
  color: grey;
}

.number {
  font-size: 30px;
  font-weight: bold;
}
</style>
